export default __webpack_public_path__ + "static/media/icon-opd.aafd1f69.svg";